import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DialogStateService {

  formProcessing$$ = new BehaviorSubject<boolean>(false);

}
